import { useEffect, useState } from "react";
import { Alert, Form, Modal } from "react-bootstrap";
import Select from "react-select";
import { CreateInvoice } from "../tally/sync/invoice";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import { userSignal } from "../../../signal/userSignal";
import { DEV_SERVER } from "../../../constants/urls";
import axios from "axios";
import { organisationSignal } from "../../../signal/organisationSignal";


export default function TallyInvoiceModal(props) {

    const [order, setOrder] = useState(props?.order)
    const [salesAccount, setSalesAccount] = useState({})
    const [taxAccount, setTaxAccount] = useState([])
    const [godown, setGodown] = useState({})
    const [company, setCompany] = useState(organisationSignal?.value?.tallyConfig?.companies[0]?.companyName)
    const [voucherType, setVoucherType] = useState("")
    const [_salesAccounts, setSalesAccounts] = useState([])
    const [_taxesLedgers, setTaxesLedgers] = useState([])
    const [_godowns, setGodowns] = useState([])
    const [_salesVoucherTypes, setSalesVoucherTypes] = useState([])
    const [isOptional, setIsOptional] = useState("No")

    const getSalesAccounts = () => {
        let _salesAccount = JSON.parse(window.localStorage.getItem(`tally-${company}-sales-ledgers`))

        _salesAccount = _salesAccount?.ENVELOPE?.BODY?.DATA?.COLLECTION?.LEDGER || []

        if (!(_salesAccount instanceof Array)){
            _salesAccount = [_salesAccount]
        }

        return _salesAccount
    }

    const getTaxesLedgers = () => {
        let _taxesLedger = JSON.parse(window.localStorage.getItem(`tally-${company}-taxes-ledgers`))

        _taxesLedger = _taxesLedger?.ENVELOPE?.BODY?.DATA?.COLLECTION?.LEDGER || []

        if (!(_taxesLedger instanceof Array)){
            _taxesLedger = [_taxesLedger]
        }

        return _taxesLedger
    }

    const getGodowns = () => {
        let _godown = JSON.parse(window.localStorage.getItem(`tally-${company}-godowns`))

        _godown = _godown?.ENVELOPE?.BODY?.DATA?.COLLECTION?.GODOWN || []

        if (!(_godown instanceof Array)){
            _godown = [_godown]
        }

        _godown = _godown.map((gd) => {
            return {
                name: gd?._attributes?.NAME || "",
                parent: gd?.PARENT?._text?.startsWith(``) || gd?.PARENT?._text?.startsWith(`\\`) ? "" : gd?.PARENT?._text
            }
        })

        return _godown
    }

    const getSalesVoucherTypes = () => {
        let _salesVoucherTypes = JSON.parse(window.localStorage.getItem(`tally-${company}-sales-voucher-types`))

        _salesVoucherTypes = _salesVoucherTypes?.ENVELOPE?.BODY?.DATA?.COLLECTION?.VOUCHERTYPE || []

        if (!(_salesVoucherTypes instanceof Array)){
            _salesVoucherTypes = [_salesVoucherTypes]
        }

        return _salesVoucherTypes
    }


    const markOrderAsSynced = useMutation(async (data) => {
        let resp = await axios.put(`${DEV_SERVER}/order/v2/markOrderSyncedWithTally/${data?.id}`, data?.body, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp.data;
    }, {
        onSuccess: (data) => {
            if (data.status) {
                toast.success(data.message);
                props.refetchOrder()
                props.close()
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error?.response?.data?.message);
            }
        }
    });


    useEffect(() => {
        if (props?.order) {
            setOrder(props?.order)
        }
    }, [props])

    useEffect(() => {
        setSalesAccounts(getSalesAccounts())
        setTaxesLedgers(getTaxesLedgers())
        setGodowns(getGodowns())
        setSalesVoucherTypes(getSalesVoucherTypes())
    }, [company])

    const handleSync = async () => {
        let resp = await CreateInvoice({ order, salesAccount, taxAccount, godown, company, voucherType, isOptional})

        if(resp){

            let body = {
                voucherNumber: resp?.toString()?.trim(),
                voucherType: voucherType?._attributes?.NAME,
                salesLedger: salesAccount?._attributes?.NAME,
                taxLedgers: taxAccount.map((tax) => tax?._attributes?.NAME),
                godown: godown?._attributes?.NAME,
                companyName: company!=="" ? company : organisationSignal?.value?.tallyConfig?.companies[0]?.companyName,
                dealerName: order?.dealer?.name,
                priceLevel: order?.tallySalesVoucherDetails?.priceLevel || "",
            }

            let masterId = ""

            if(order?.dealer?.tallyDetails){
                let idx = 0;
                for(let i=0; i<order?.dealer?.tallyDetails.length; i++){
                    if(order?.dealer?.tallyDetails[i]?.companyName === body?.companyName){
                        idx = i
                        break
                    }
                }

                masterId = order?.dealer?.tallyDetails[idx]?.masterId
            }

            body.dealerMasterId = masterId

            markOrderAsSynced.mutate({ id: order?.id, body: body})

        }else{
            toast.error("Failed to sync with Tally")
        }
    }

    const checkQuantity = () => {

        let ok = true

        let items = order?.orderItems || []

        for (let i = 0; i < items.length; i++) {
            let item = items[i]

            let product = order?.products[item?.productId] || {}

            if (product?.tallyQty < item?.quantity) {
                ok = false
                break
            }
        }

        return ok
    }

    const checkPrice = () => {

        let ok = true
        let productName = ""

        let items = order?.orderItems || []

        for (let i = 0; i < items.length; i++) {
            let item = items[i]

            let product = order?.products[item?.productId] || {}

            if (product?.tallyItemPrice !== item?.price) {
                ok = false
                productName = product?.name
                break
            }
        }

        return { ok, productName }
    }

    return (
        <Modal fullscreen show={props?.show} onHide={props?.close} style={{ height: "100%", width: "100%" }}>
            <Modal.Header closeButton>
                <Modal.Title>Sync With Tally</Modal.Title>
            </Modal.Header>

            <Modal.Body>

                {checkQuantity() ? <Alert variant="success"><i className="fas fa-check-circle me-2"></i> Quantity check passed</Alert> : <Alert variant="warning"><i className="fas fa-exclamation-triangle me-2"></i> Quantity check failed</Alert>}

                {checkPrice().ok ? <Alert variant="success"><i className="fas fa-check-circle me-2"></i> Price check passed</Alert> : <Alert variant="warning"><i className="fas fa-exclamation-triangle me-2"></i> Price of {checkPrice().productName} is not same as in Tally</Alert>}

                {(organisationSignal?.value?.tallyConfig?.companies && organisationSignal?.value?.tallyConfig?.companies?.length>0) && <Form.Group className="mb-3 col-12 mt-5 align-self-center" controlId="formBasicName">
                    <Form.Label>Select Company</Form.Label>
                    <Select
                        options={organisationSignal?.value?.tallyConfig?.companies?.map((company) => ({ value: company?.companyName, label: company?.companyName }))}
                        placeholder="Select Company"
                        onChange={(e) => {
                            if (e && e?.value) {
                                setCompany(e?.value)
                            } else {
                                setCompany("")
                            }
                        }}
                        value={{ value: company, label: company }}
                        isClearable
                    />
                </Form.Group>}


                <Form.Group className="mb-3 col-12 mt-5 align-self-center" controlId="formBasicName">
                    <Form.Label>Select Voucher Type</Form.Label>
                    <Select
                        options={_salesVoucherTypes.map((voucher) => ({ value: voucher, label: voucher?._attributes?.NAME }))}
                        placeholder="Select Voucher Type"
                        onChange={(e) => {
                            if (e && e?.value) {
                                setVoucherType(e?.value)
                            }
                        }
                        }
                        value={{ value: voucherType, label: voucherType?._attributes?.NAME }}
                        isClearable
                    />
                </Form.Group>

                <Form.Group className="mb-3 col-12 mt-5 align-self-center" controlId="formBasicName">
                    <Form.Label>Select Sales Ledger</Form.Label>
                    <Select
                        options={_salesAccounts.map((account) => ({ value: account, label: account?._attributes?.NAME }))}
                        placeholder="Select Sales Account"
                        onChange={(e) => {
                            console.log(e)
                            if (e && e?.value) {
                                setSalesAccount(e?.value)
                            } else {
                                setSalesAccount({})
                            }
                        }}
                        value={{ value: salesAccount, label: salesAccount?._attributes?.NAME }}
                        isClearable
                    />
                </Form.Group>

                <Form.Group className="mb-3 col-12 mt-5 align-self-center" controlId="formBasicName">
                    <Form.Label>Select Tax and Duties</Form.Label>
                    <Select
                        
                        options={_taxesLedgers.map((account) => ({ value: account, label: account?._attributes?.NAME }))}
                        placeholder="Select Tax and Duties"
                        onChange={(e) => {
                            if (e && e?.values) {
                                let temp = []
                                e.map((tax) => {
                                    temp.push(tax.value)
                                })
                                setTaxAccount(temp)
                            } else {
                                setTaxAccount([])
                            }
                        }}
                        isClearable
                        isMulti

                        value={taxAccount.map((account) => ({ value: account, label: account?._attributes?.NAME }))}
                    />
                </Form.Group>

                <Form.Group className="mb-3 col-12 mt-5 align-self-center" controlId="formBasicName">
                    <Form.Label>Select Godown</Form.Label>
                    <Select
                        options={_godowns.map((godown) => ({ value: godown, label: godown?.name }))}
                        placeholder="Select Godown"
                        onChange={(e) => {
                            console.log(e)
                            if (e && e?.value) {
                                setGodown(e?.value)
                            } else {
                                setGodown({})
                            }
                        }}
                        value={{ value: godown, label: godown?.name }}
                        isClearable
                    />
                </Form.Group>

                <Form.Group className="mb-3 col-12 mt-5 align-self-center" controlId="formBasicName">
                    <Form.Label>Is Optional</Form.Label>
                    <Select
                        options={[{value: "Yes", label: "Yes"}, {value: "No", label: "No"}]}
                        placeholder="Is Optional"
                        onChange={(e) => {
                            if (e && e?.value) {
                                setIsOptional(e?.value)
                            } else {
                                setIsOptional("No")
                            }
                        }}

                        value={{ value: isOptional, label: isOptional }}
                    />
                </Form.Group>

            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-light" onClick={props?.onHide}>Close</button>
                <button className="btn btn-primary" onClick={handleSync}>Sync</button>
            </Modal.Footer>
        </Modal>
    )
}